// removed by extract-text-webpack-plugin
module.exports = {"latestPosts":"styles__latestPosts___ckfOu"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/latestPosts/styles.css
// module id = ldxT
// module chunks = 3